import SvgIcon from "./IconPaperclip.svg?react";
const IconPaperclip = SvgIcon;
export default IconPaperclip;
